"use client";
import React from "react";
import gsap from "gsap";
import dynamic from "next/dynamic";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Image from "next/image";
import { parseHtml, toWebp } from "@/utils/common";
const Conclusion = dynamic(() => import("./conclusion"), { ssr: true });
import styles from "./styles.module.scss";
gsap.registerPlugin(ScrollTrigger);

interface CareerPromisesProps {
  data: {
    image: any;
    title: string;
    description: string;
    Conclusion: string;
  };
}
const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const CareerPromises = ({ data }: CareerPromisesProps) => {
  return (
    <>
      <div>
        <section className=" bg-background-dark relative z-0 xl:py-[100px] lg:py-[70px] py-[56px]">
          {/* Shapes */}
          <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
            <Image
              src="/images/banner-left-layer-mobile.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-left-layer-tablet.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-left-layer-desktop.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden lg:block"
            />
          </div>
          <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
            <Image
              src="/images/banner-right-layer-mobile.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-right-layer-tablet.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-right-layer-desktop.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden lg:block"
            />
          </div>
          <div className="container z-1 relative max-w-[1020px] mx-auto ">
            <div>
              <h2 className="font-bold text-heading-5 text-white mb-[40px]">
                {data?.title ?? ""}
              </h2>
            </div>
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-[24px] ">
              {/* Left side: Steps */}
              <div className="order-last lg:order-first">
                <div className={`${styles.UseCaseAlternate}`}>
                  {data?.description ? parseHtml(data?.description) : ""}
                </div>
              </div>

              {/* Right side: Sticky image */}
              <div className=" order-first lg:order-last ">
                <div className="xl:sticky xl:top-[100px]">
                  {data?.image?.data?.attributes?.url && (
                    <Image
                      src={toWebp(
                        `${baseUrl}${data?.image?.data?.attributes?.url}`,
                      )}
                      alt="Alternative Flow Illustration"
                      className="w-full h-[288px] object-cover"
                      width={495}
                      height={288}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        <Conclusion title="Conclusion" text={data?.Conclusion} />
      </div>
    </>
  );
};

export default CareerPromises;
